import { render, staticRenderFns } from "./SpecialistGeneralInfo.vue?vue&type=template&id=51bb186e&scoped=true"
import script from "./SpecialistGeneralInfo.vue?vue&type=script&lang=js"
export * from "./SpecialistGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./SpecialistGeneralInfo.vue?vue&type=style&index=0&id=51bb186e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb186e",
  null
  
)

export default component.exports